import React from 'react';

import { IBloackAppDownloadPanel } from '../../../queries/fragments/blockAppDownloadPanel';
import ImageWrapper from '../../image-wrapper/Image-wrapper';

interface ViewOnMapProps {
  downloadPanel: IBloackAppDownloadPanel;
  panelclasses?: string;
}

const MobileAppLinks = ({ downloadPanel, panelclasses }: ViewOnMapProps) => {
  const { title, appStoreLink, playStoreLink } = downloadPanel;

  const isPlayStoreSvgIcon = !!playStoreLink?.image?.svg?.content;
  const isAppStoreSvgIcon = !!appStoreLink?.image?.svg?.content;
  return (
    <div
      className={`mb-4 mt-6  rounded-xl bg-background-primary-light p-4 lg:bg-background-primary ${
        panelclasses ? panelclasses : ''
      }`}
    >
      <h5 className="text-center font-title text-headingxs text-text-default">
        {title}
      </h5>
      <div className="flex items-center justify-center">
        {/* Link to Google Play Store */}
        <a
          href={playStoreLink?.externalLink}
          target={playStoreLink?.openInNewWindow ? '_blank' : ''}
          rel="noopener noreferrer"
        >
          <ImageWrapper
            gatsbyImageData={playStoreLink.image?.gatsbyImageData}
            file={playStoreLink?.image?.file}
            svg={playStoreLink?.image?.svg}
            alt={
              playStoreLink?.image?.description
                ? playStoreLink?.image.description
                : ''
            }
            className={`h-12 ${isPlayStoreSvgIcon ? 'mx-1 mt-3 w-28' : 'w-32'}`}
          />
        </a>
        {/* Link to App Store */}
        <a
          href={appStoreLink?.externalLink}
          target={appStoreLink?.openInNewWindow ? '_blank' : ''}
          rel="noopener noreferrer"
        >
          <ImageWrapper
            gatsbyImageData={appStoreLink?.image?.gatsbyImageData}
            file={appStoreLink?.image?.file}
            svg={appStoreLink?.image?.svg}
            alt={
              appStoreLink?.image?.description
                ? appStoreLink?.image.description
                : ''
            }
            className={`h-12 ${isAppStoreSvgIcon ? 'mx-1 mt-3 w-28' : 'w-32'}`}
          />
        </a>
      </div>
    </div>
  );
};

export default MobileAppLinks;
